import React from "react";
import {
  FormControl,
  FormLabel,
  RadioGroup as MuiRadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import "./radioGroup.scss";

export default function RadioGroup(props) {
  const { name, label, value, onChange, items, error } = props;

  return (
    <FormControl>
      {label && <FormLabel>{label}</FormLabel>}
      <MuiRadioGroup row name={name} value={value} onChange={onChange}>
        {items.map((item) => (
          <FormControlLabel
            key={item.id}
            value={item.id}
            control={<Radio />}
            label={item.title}
          />
        ))}
      </MuiRadioGroup>
      {error ? <p className="error">{error}</p> : null}
    </FormControl>
  );
}
